<template>
	<div class="enlaces-container-all-1" id="content_todo">
		<div class="enlaces-mosaico-1">
			<div class="mosaico-1-wrapper">
				<div class="img-wrapper">
					<div class="mosaico-1-logo">
						<img :src="url_images + url_logo">
					</div>
				</div>
				<div class="title-and-description">
					<h4>{{ name }}</h4>
					<h5>{{ description }}</h5>
				</div>
				<div class="managment-buttons">
					<button v-for="(item, index) in option_link" :key="index" class="boton" @click="setLocation(item.button_link)" :id="'boton_'+index">{{ item.button_title }}</button>
				</div>
				<div class="copyright">
					<h4>Powered by VinApp</h4>
				</div>	
			</div>
		</div>
	</div>
</template>
<style type="text/css" scoped>

		@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

		*{
			padding: 0;
			margin: 0;
			box-sizing: border-box;
		}

		*:focus{
			outline: none !important;
		}

		.enlaces-container-2{
			width: 100%;
			min-height: 100vh;
			display: flex;
			justify-content: center;
			align-items: flex-start;
		}

		.enlaces-mosaico-2{
			width: 100%;
			height: auto;
			display: block;
			text-align: center;
		}

		.path-container{
			width: 100%;
			height: 25vh;
			background: red;
			clip-path: polygon(0% 15%, 0 0, 15% 0%, 85% 0%, 100% 0, 100% 15%, 100% 93%, 86% 93%, 79% 100%, 18% 100%, 12% 93%, 0 93%);
		}

		.copyright{
			width: 100%;
			text-align: center;
		}

		.copyright h4{
			color: #fff;
			font-family: 'Poppins', sans-serif;
			font-size: 15px;
			font-weight: 500;
		}

		.managment-buttons{
			width: 100%;
			min-height: 55vh;
			display: block;
			text-align: center;
			padding: 10px 20px;
		}

		@media only screen and (min-width: 1280px) and (max-width: 1920px){
			.managment-buttons{
				width: 35%;
				margin: 0 auto;
			}
		}
		

		.managment-buttons button{
			width: 100%;
			color: #fff;
			border: none;
			padding: 15px 0px;
			font-family: 'Poppins', sans-serif;
			font-size: 15px;
			margin-bottom: 15px;
			border-radius: 5px;
		}

		.managment-buttons button:hover{
			color: #000;
			background: #fff;
		}

		.managment-buttons button:focus{
			color: #000;
			background: #fff;
		}

		.title-and-description{
			width: 100%;
			height: auto;
			text-align: center;
			padding: 15px 15px 10px 15px;
		}

		.title-and-description h4{
			color: #fff;
			font-family: 'Poppins', sans-serif;
			font-size: 20px;
			font-weight: 500;
		}

		.title-and-description h5{
			color: #fff;
			font-family: 'Poppins', sans-serif;
			margin-top: 3px;
			font-size: 15px;
			font-weight: 400;
		}

		.enlaces-mosaico-1{
			width: 100%;
			height: auto;
			display: block;
			text-align: center;
			z-index: 500;
		}

		.mosaico-1-wrapper{
			width: 100%;
			height: auto;
			display: block;
		}

		.img-wrapper{
			width: 100%;
			height: auto;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.mosaico-1-logo{
			width: 90px;
			height: 90px;
			border-radius: 50%;
			text-align: center;
			border: 3px solid #fff;
			overflow: hidden;
			background: #fff;
		}

		.mosaico-1-logo img{
			width: 100%;
			height: auto;
		}


		.enlaces-container-all-1{
			width: 100%;
			min-height: 100vh;
			display: flex;
			justify-content: center;
			align-items: center;
			/*background: url("https://back.vinapp.co/banner-login.jpg");*/
			background-size: cover;
			background-position: center center;
			background-attachment: fixed;
		}

		/*.enlaces-container-all-1:before{
			content: '';
			width: 100%;
			min-height: 100vh;
			position: absolute;
			top: 0;
			background: rgba(0, 0, 0, .6);
		}*/

		.schedule-success{
			width: 100%;
			height: 100vh;
			display: flex;
			justify-content: center;
			align-items: center;
			position: fixed;
			top: 0;
			left: 0;
			background: rgba(0, 0, 0, .6);
		}

		.confirm-wrapper{
			width: 80%;
			background: #fff;
			padding: 20px 15px;
			border-radius: 10px;
			text-align: center;
			display: block;
		}

		.confirm-wrapper i{
			font-size: 65px;
			color: #22BDDC;
		}

		.confirm-wrapper h4{
			font-family: 'Poppins', sans-serif;
			margin-top: 7px;
			font-size: 16px;
			font-weight: 500;
		}

		.confirm-wrapper p{
			font-family: 'Poppins', sans-serif;
			margin-top: 4px;
			font-size: 12px;
			font-weight: 500;
		}	

		.single-input{
			width: 100%;
		}

		.single-input select{
			width: 100%;
			padding: 17px;
			background: #F8F8FA;
			cursor: pointer;
			color: #868688;	
			border-radius: 5px;
			border: none;
			appearance: none;
			-webkit-appearance: none;
			background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
			background-repeat: no-repeat;
			background-size: 28px;
			background-position-x: 97%;
		  	background-position-y: 11px;
		  	font-family: 'Poppins', sans-serif;
			font-size: 14px;	
		}
	</style>
<script>
	import axios from 'axios';
	export default{
		data(){
			return{
               uri:'',
               name:'',
               description:'',
               option_link:[],
               images: [],
               url_images: "https://back.vinapp.co/",
               url_logo:''
			}
		},
		methods:{
			setLocation(enlace){
				location.href = enlace;
			},
			getCompaniesInfo(id_companie){
		      axios
		      .post('https://back.vinapp.co/api/pwa/get-link-v2',{id_companie : id_companie})
		      .then(res => {
		      	var self = this;
		      	this.name=res.data.name
				this.description=res.data.description;
				this.option_link=res.data.link_config;
				this.url_logo = res.data.image_logo.split(";")[0];
				if (res.data.background_image) {
					this.images = res.data.background_image.split(";")[0];
					const backgroundImageUrl = `${this.url_images}${this.images}`;
					
					// Establecer la imagen de fondo utilizando JavaScript
					document.getElementById("content_todo").style.backgroundImage = `url('${backgroundImageUrl}')`;

					document.getElementById("content_todo").style.backgroundSize = "100% 100%";
					document.getElementById("content_todo").style.backgroundRepeat = "no-repeat";
					}

				setTimeout(function(){
					self.updateButtons(self.option_link, res.data.background_color, res.data.font_color);
				},1000);
				
		      }).catch(err => {
				console.log(err)
		      });
		    },
		    updateButtons(listado, fondo, color){
		    	listado.forEach((item, index) =>{
		    		document.getElementById(`boton_${index}`).style.backgroundColor = fondo;
		    		document.getElementById(`boton_${index}`).style.color = color;
		    	});
		    },
			getCompanies(){
		      axios
		      .post('https://back.vinapp.co/api/get-companies-reservetion-v2',{uri:this.uri})
		      .then(res => {
                if (res.data) {
                	this.getCompaniesInfo(res.data.id_companie);
                }
		      }).catch(err => {
				console.log(err)
		      });
		    },
		},
		mounted(){
		   if (this.$route.params.id) {
				this.uri=this.$route.params.id
				this.getCompanies()
			}	
		}
	}
</script>